import Vue from 'vue';
import Router from 'vue-router';

import guestRoutes from './guest';
import adminRoutes from './admin';
import userRoutes from './user';
import pubRoutes from './pub';

import PageNotFound from '../views/PageNotFound.vue';

Vue.use(Router);

const router = new Router({
  routes: [
    ...guestRoutes,
    ...userRoutes,
    ...adminRoutes,
    ...pubRoutes,
    {path: '*', component: PageNotFound},
  ],
});

// Add a global beforeEach guard to handle the redirection
router.beforeEach((to, from, next) => {
  console.log('beforeEach');
  console.log(window.location.hostname);
  const currentDomain = window.location.hostname;
  if (currentDomain === 'eventmanager.salat.tech') {
    const newUrl = new URL(window.location.href);
    newUrl.hostname = 'eventmanager.rubas.at';
    window.location.replace(newUrl.toString());
  } else {
    next();
  }
});

export default router;
